import {BottomNavigation, BottomNavigationAction, Paper} from '@mui/material';
import {
  Broadcast,
  GlobeHemisphereWest,
  MapTrifold,
  Question,
  User,
} from '@phosphor-icons/react';
import {selectForecastMapsEnabled} from '@smartmixin/core';
import {messages} from '@smartmixin/i18n';
import React from 'react';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router';
import {navigation} from '../../theme/tokens';

const BottomNav: React.FC = () => {
  const {formatMessage} = useIntl();
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const forecastMapsEnabled = useSelector(selectForecastMapsEnabled);

  const getCurrentValue = (): string => {
    if (pathname.startsWith('/app/stations')) return 'stations';
    if (pathname.startsWith('/map')) return 'map';
    if (pathname.startsWith('/forecast-maps')) return 'forecastMaps';
    if (pathname.startsWith('/help')) return 'help';
    if (pathname.startsWith('/app/settings')) return 'profile';
    return 'stations';
  };

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    switch (newValue) {
      case 'stations':
        navigate('/app/stations/');
        break;
      case 'map':
        navigate('/map/');
        break;
      case 'forecastMaps':
        navigate('/forecast-maps');
        break;
      case 'help':
        navigate('/help');
        break;
      case 'profile':
        navigate('/app/settings/');
        break;
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderRadius: 0,
        borderTop: 1,
        borderColor: 'divider',
      }}
      elevation={0}>
      <BottomNavigation
        value={getCurrentValue()}
        onChange={handleChange}
        showLabels
        sx={{
          height: navigation.bottomNavHeight,
          backgroundColor: 'background.paper',
        }}>
        <BottomNavigationAction
          label={formatMessage(messages.common.weatherStations)}
          value="stations"
          icon={<Broadcast />}
        />
        <BottomNavigationAction
          label={formatMessage(messages.common.weatherMap)}
          value="map"
          icon={<MapTrifold />}
        />
        {/* Flag-gated (forecast_maps, fail-closed) */}
        {forecastMapsEnabled && (
          <BottomNavigationAction
            label={formatMessage(messages.forecastMaps.title)}
            value="forecastMaps"
            icon={<GlobeHemisphereWest />}
          />
        )}
        <BottomNavigationAction
          label={formatMessage(messages.common.help)}
          value="help"
          icon={<Question />}
        />
        <BottomNavigationAction
          label={formatMessage(messages.settings.settings)}
          value="profile"
          icon={<User />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
